import { LicenseInfo } from '@mui/x-license';

export const initializeMuiLicense = () => {
    LicenseInfo.setLicenseKey(
        'a2b7921078884a2844ef09830fd40f9bTz0xMjk3MTMsRT0xODExNzIxNTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y',
    );
}
